import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const ASPHALT = "#3f4044";
const MARKING = "#e8e6e0";

export const roadIntersection = defineModel({
  id: "road-intersection",
  batchId: "modern",
  name: "Road (intersection)",
  tags: ["modern", "outdoor", "ground", "street", "road", "asphalt", "intersection"],
  summary: "An asphalt intersection tile with white corner ticks.",
  description:
    "A one-tile road intersection of the Modern Living kit: a 1x1 m asphalt " +
    "slab (0.06 m thick) with a small white tick at each corner, reading as " +
    "an intersection tile from above without full lane lines. Tiles " +
    "seamlessly with every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    const ticks: Part[] = [];
    for (const sx of [-1, 1]) {
      for (const sz of [-1, 1]) {
        ticks.push({
          geometry: new THREE.BoxGeometry(0.1, 0.012, 0.1),
          color: MARKING,
          position: [sx * 0.41, 0.06, sz * 0.41],
        });
      }
    }
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: ASPHALT, position: [0, 0.03, 0] },
      ...ticks,
    ];
  },
  animations: [],
});
